<template>
  <div class="redact_container">
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      highlight-current-row
      stripe
      border
      v-loading="tableLoading"
    >
      <el-table-column property="number"  label="序号" width="55" align="center">
      </el-table-column>
      <el-table-column property="maintainYear" label="年度"> </el-table-column>
      <el-table-column property="maintainName" label="名称"> </el-table-column>
      <el-table-column property="createUserName" label="创建者"> </el-table-column>
      <el-table-column property="createTime" label="创建时间"> </el-table-column>
      <el-table-column property="file" label="附件"> </el-table-column>
      <el-table-column property="remark" label="备注"> </el-table-column>
    </el-table>
    <div class="paging_box">
      <!--  :current-page="currentPage4" -->
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="tableParams.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      tableData: [],
      total: 0,
      tableLoading: false,
      tableParams: {
        id: 0,
        page: 1,
        limit: 10,
      },
    };
  },
  components: {
  },
  props: {
    netId: Number,
  },
  created() {},
  methods: {
    getList() {
      this.tableLoading = true;
      this.tableParams.id = this.netId;
      this.$http.getMaintainRecord(this.tableParams).then((res) => {
        this.tableLoading = false;
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.info(res.msg);
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../redact.less";
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/detail/detail_carMaintenancePlan.vue